import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import CustomerDashboard from './pages/CustomerDashboard';
import RunnerDashboard from './pages/RunnerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PaymentResult from './pages/PaymentResult';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import SplashScreen from './components/SplashScreen';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/customer" element={
        <ProtectedRoute requiredRole="customer">
          <CustomerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/runner" element={
        <ProtectedRoute requiredRole="runner">
          <RunnerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/payment/success" element={<PaymentResult variant="success" />} />
      <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
      <Route path="/payment/failure" element={<PaymentResult variant="failure" />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={
        <ProtectedRoute requireAdmin>
          <AdminDashboard />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  const [splashDone, setSplashDone] = useState(
    typeof window !== 'undefined' && sessionStorage.getItem('splashShown') === '1'
  );

  const handleSplashFinish = () => {
    sessionStorage.setItem('splashShown', '1');
    setSplashDone(true);
  };

  return (
    <BrowserRouter>
      {!splashDone && <SplashScreen onFinish={handleSplashFinish} />}
      <Toaster position="top-center" />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;